import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  isChrome(): boolean {
    const userAgent: string = navigator.userAgent;
    return userAgent.includes('Chrome') && !userAgent.includes('Edg');
  }

  isEdge(): boolean {
    const userAgent: string = navigator.userAgent;
    return userAgent.includes('Chrome') && userAgent.includes('Edg');
  }
}
